<template>
  <b-modal id="agent-upload" hide-footer title="Upload Agents CSV">
    <div v-if="notification.status == 'unloaded'">
      <strong>AGENT CSV TEMPLATE</strong><br />
      <b-link @click="csv_template" v-analytics:click="['download_agent_template',{element:'Suppliers'}]"
      >Click to download template</b-link><br />
      <div class="my-2"></div>
      <strong>UPLOAD AGENTS</strong><br />
      <b-form @submit.prevent="upload_file" class="mt-1">
        <b-form-group>
          <input
            type="file"
            class="form-control-file"
            accept=".csv"
            @change="pick_file"
            v-analytics:change="['attach_agent_csv',{element:'Suppliers'}]"
          />
        </b-form-group>
        <b-button
          type="submit"
          variant="primary"
          :disabled="csv.is_empty()"
          class="w-100"
          >UPLOAD FILE</b-button
        >
      </b-form>
    </div>
    <div v-else>
      <upload-notification
        :notify="notification"
        @clear-file="clear_file"
      ></upload-notification>
    </div>
  </b-modal>
</template>
<script>
import { CsvUpload } from "../upload";
import UploadNotification from "../UploadNotification.vue";
export default {
  components: { UploadNotification },
  mixins: [CsvUpload],
  data() {
    return {
      upload_url: process.env.VUE_APP_BACKEND+"/api/v3/village-agents/:upload_csv",
      csv_url: process.env.VUE_APP_BACKEND+"/api/v3/village-agents/csv_template",
      csv_name:"agents_template.csv"
    };
  },
};
</script>